<template>
  <div>
    <el-dialog
      :visible.sync="centerDialogVisible"
      width="1100px"
      height="536px"
      center
      :before-close="handleClose"
    >
      <div class="buydetail">
        <div class="bgimg">
          <img src="static/img/sign-login.png" alt="" />
        </div>
        <div class="rightdetail">
          <!-- <div class="cuohao">
            <img src="static/icon/17cuowu@2x.png" alt="" />
          </div> -->
          <ul class="kalist">
            <!-- <li class="kaitem">
              <span class="katitle">月</span>
              <span class="kacontent marginTop">300元/月 </span
              ><span class="kades ver">收书全面<br />突破传统</span>
            </li> -->
            <li class="kaitem">
              <!-- orderDetail.orderIcon -->
              <img :src="baseUrl + kaimg" alt="" />
            </li>
          </ul>
          <div v-show="showCode" class="qrcode" ref="qrcode"></div>
          <div v-show="!showCode" class="zyqrcode">
            <div class="zyqrcodeimg">
              <img src="/static/products/code.jpg" alt="" />
            </div>
            <div class="zyqrcodetxt" @click="openbindmobile">点我登录</div>
          </div>
          <div class="wxpay">
            <img src="/static/icon/wxpay.png" alt="" />

            <p>微信支付</p>
          </div>
          <div class="tongyi">
            <p>支付即同意《儒藏（精华篇）数字化平台VIP会员服务协议》</p>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import eventBus from "@/utils/eventBus.js"
import {
  orderDetail,
  getImgCode,
  getInfo
} from "@/api/api"
export default {
  name: "payPage",
  props: {
    centerDialogVisible: false,
    orderId: 0,
    kaimg: ''
  },
  data () {
    return {
      baseUrl: window.__baseUrl__,
      timer: null,
      code: 0,
      orderDetail: {},
      link: '',
      showCode: true,//是否展示二维码  总平台账号没手机号遮掩二维码 必须绑定手机号
    }
  },
  mounted () {
    this.jugepath()
    // this.getImgCode()
    this.$bus.$on("getImgCode", () => {

      this.getImgCode()
    })
  },
  methods: {
    openbindmobile () {
      eventBus.$emit("openBindMobile", true)
    },
    getOrderDetail (orderId) {
      orderDetail(orderId).then((d) => {
        if (d.code == 200) {
          this.orderDetail = d.data
        } else {
          this.$message.error(d.msg)
        }
      })
    },
    jugepath () {
      getInfo().then(d => {
        if (d.code == 200) {
          if (d.user.isCompany == 1 && (!d.user.mobile || d.user.mobile == '')) {
            this.showCode = false
          } else {
            // this.showCode = false//测试完注释
            this.getImgCode()
          }

        }
      })
    },
    getImgCode () {
      this.showCode = true
      getImgCode({ orderId: this.orderId }).then((dd) => {
        console.log(dd, 'zhifu')
        // this.link = "weixin://wxpay/bizpayurl?pr=sODcWp7zz"
        this.link = dd.prepay
        this.qrcode(160, 160, this.link, 'canvas')
      })

      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.getOrderDetail(this.orderId)
          if (this.orderDetail.payStatus == 1) {
            // 关闭弹出框
            this.closeCode()
            eventBus.$emit("getUserInfo")
            this.code = 200
            this.$message({
              message: '支付成功',
              type: 'success'
            })

            // this.$router.push({ path: '/uc' })

          }
        }, 1000)
      }
    },
    qrcode (qWidth, qHeight, qText, qRender) {
      let el = this.$refs.qrcode
      new QRCode(el, {
        width: qWidth,
        height: qHeight,
        text: qText,
        render: qRender
      })
    },
    // 关闭弹框,清除已经生成的二维码
    closeCode () {
      // this.dialogVisible = false
      clearInterval(this.timer)
      this.timer = null
      this.$emit("changeVisible", false)
      this.$refs.qrcode.innerHTML = ""
    },
    handleClose (done) {

      // 判断是否真的支付了
      if (this.code == 200) {
        console.log("支付成功啦")

      }
      clearInterval(this.timer)
      this.timer = null
      this.$emit("changeVisible", false)
      // done()

      this.$refs.qrcode.innerHTML = ""
    }
  },
  beforeDestroy () {
    this.$bus.$off("getImgCode")
  }

}
</script>

<style scoped lang="less">
/deep/.el-dialog--center .el-dialog__body,
/deep/.el-dialog__header {
  padding: 0;
}
/deep/.el-dialog {
  border-radius: 10px;
}
p,
div {
  margin: 0;
  padding: 0;
}
img {
  width: 100%;
  height: 100%;
}
.ver {
  writing-mode: vertical-rl;
}
.textright {
  text-align: right;
}
.marginTop {
  margin-top: 76px;
}
.buydetail {
  display: flex;
  justify-content: space-between;
  .kaitem {
    background-color: #ebeef5;
  }
  .qrcode {
    width: 180px;
    height: 180px;
    border: 1px solid #00c800;
    padding: 9px;
  }
  .zyqrcode {
    width: 180px;
    height: 180px;
    border: 1px solid #00c800;
    padding: 9px;
    position: relative;
    .zyqrcodeimg {
      width: 100%;
      height: 100%;
    }
    .zyqrcodetxt {
      width: 100%;
      height: 100%;
      text-align: center;
      line-height: 180px;
      position: absolute;
      background: rgba(255, 255, 255, 0.9);
      font-size: 22px;
      text-decoration: underline;
      text-decoration-thickness: 1px;
      left: 0;
      top: 0;
      cursor: pointer;
    }
  }
  .wxpay {
    display: flex;
    align-items: center;
    img {
      width: 28px;
      height: 28px;
      margin-right: 4px;
    }
    p {
      font-family: "FangZheng-FanTi";
      font-size: 16px;
      font-weight: 400;
      color: #959595;
    }
  }
  .bgimg {
    height: 536px;
    width: auto;
  }
  .rightdetail {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 38px 16px 50px 0;
    .cuohao {
      width: 18px;
      height: 18px;
      // margin-right: 10px;
    }
    .tongyi {
      font-family: "FangZheng-FanTi";
      font-size: 19px;
      font-weight: 400;
      color: #959595;
    }
  }
}
.kaitem {
  width: 293px;
  height: 178px;
  background: #ffffff;
  box-shadow: 0px 3px 8px 2px rgba(125, 125, 125, 0.3);
  border-radius: 10px;
  color: #344672;
  display: flex;
  justify-content: space-between;

  overflow: hidden;
  .katitle {
    padding: 20px 0;
    font-size: 130px;
    font-weight: bold;
    margin-left: -26px;
    color: #1c3d85;
  }
  .kayue {
    flex: 1;
    display: flex;
    justify-content: space-between;
  }
  .kastart {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .kaend {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  .kacontent {
    font-size: 27px;
    font-weight: bold;
    margin-bottom: 0px;
  }
  .kades {
    font-size: 27px;
    font-weight: bold;
    color: #cc9933;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/payPage.vue